import { Component, Inject, OnInit } from '@angular/core';
import { ReusableClasses } from '../reusableclassesAndFunctions/reusable-classes';
import { EncryptionService } from '../../encryption/encryption.service';
import * as jwt_decode from 'jwt-decode';
import { ToastrService } from 'ngx-toastr';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { StatusConstant } from '../status/status-constant';
import { SettingService } from 'src/app/applicationModules/settings/services/settingService/setting.service';
import { LoaderService } from '../../shared/loader/loader.service';

@Component({
  selector: 'app-attachAIAutomationTemplate.component',
  templateUrl: './attachAIAutomationTemplate.component.html',
  styleUrls: ['./attachAIAutomationTemplate.component.scss']
})

export class AttachAIAutomationTemplateComponent implements OnInit {
  organizationId: string;
  databaseId: string;
  currentUser: any;
  responseHolder: any;
  spinner: boolean = false;
  OfficeIDList: any = [];
  myOfficeID: any;

  currentIndex: number = 0;
  aiAutomationTemplateID: number = 0;
  ShowNoRecordFoundAITemplates: boolean = false;
  selectedFolderIdforAITemplate: number = 0;
  aITemplateList: any = [] = [];
  ShowNoRecordFound: boolean = false;
  FolderIdForAITemplates: number = 0;
  selectedFolderName: string = "";
  OpenPopUpFrom: string = "";
  searchType: number = 0;

  constructor(public dialogRef: MatDialogRef<AttachAIAutomationTemplateComponent>,
    private encryptionAlgo: EncryptionService,
    private reusableClass: ReusableClasses, private toastr: ToastrService,
    @Inject(MAT_DIALOG_DATA) public data: any, private statusConst: StatusConstant,
    private settingsService: SettingService, private loaderService: LoaderService) {
    const encryptedtoken = sessionStorage.getItem('userToken');
    this.databaseId = sessionStorage.getItem('databaseId') ?? '';
    this.organizationId = sessionStorage.getItem('organizationID') ?? '';
    if (encryptedtoken != null) {
      const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
      this.currentUser = jwt_decode(token);
      var offices = JSON.parse(sessionStorage.getItem('officeList') || '[]');
      offices.forEach((oe: any) => {
        this.OfficeIDList.push(oe.officeID);
        if (oe.isMyoffice == true)
          this.myOfficeID = oe.officeID;
      });
    }
  }

  ngOnInit(): void {
    this.selectedFolderName = this.data.selectedFolderName;
    this.aiAutomationTemplateID = 0;
    this.FolderIdForAITemplates = this.data.fileManagerItemID;
    this.searchType = this.data?.searchType ?? 0;
    this.getAIAutomationTemplates();
  }

  getAIAutomationTemplates() {
    this.loaderService.show();
    var ReqModel = {
      keyword: "",
      searchType: this.searchType,
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId)
    }
    this.settingsService.getAIAutomationTemplates(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.aITemplateList = this.responseHolder.data.templates;
          if (this.aITemplateList == null) {
            this.aITemplateList = [];
          }
          if (this.aITemplateList.length > 0) {
            this.ShowNoRecordFound = false;
          } else {
            this.ShowNoRecordFound = true;
          }
        }
        else {
          this.ShowNoRecordFound = true;
          this.aITemplateList = [];
          this.loaderService.hide();
        }
      }
      else {
        this.aITemplateList = [];
        this.ShowNoRecordFound = true;
        this.loaderService.hide();
      }
    });
  }

  SelectAITemplate(data: any) {
    this.aiAutomationTemplateID = data.aiAutomationTemplateID;
  }

  getAIAutomationCategoryForImport(e: any, i: any) {
    this.currentIndex = i;
  }

  closeAIAutomationTemplate() {
    this.dialogRef.close();
  }

  attachAIAutomationTemplate() {
    if (this.data.From == "Referral Management") {
      this.SetDefaultFodlerForReferral();
      return;
    }
    if (this.data.From == "Core") {
      this.SetDefaultAutomationFolderForCore();
      return;
    }
    var ReqModel1 = {
      fileID: this.FolderIdForAITemplates,
      aiAutomationTemplateID: this.aiAutomationTemplateID,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID: this.myOfficeID,
      CType: 1,
      CID: sessionStorage.getItem("transactionID")
    }
    this.dialogRef.close('Added');
    this.toastr.success('The automation process may take a few minutes. You can continue other tasks on Flowtrics and refresh the list later to check the status.', '', {
      timeOut: 9000,
    });
    this.settingsService.aIAutomationRunManuallyForFile(ReqModel1).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
      } else {
        this.loaderService.hide();
      }
    });
  }

  SetDefaultFodlerForReferral() {
    var reqModel = {
      folderID: this.data.fileManagerItemID,
      aiAutomationTemplateID: this.aiAutomationTemplateID,
      type: 1,//  1 for referral  , 2 for Core
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId)
    }
    this.loaderService.show();
    this.settingsService.setDefaultFodlerForReferral(reqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.dialogRef.close("RecordAdded");
          this.toastr.success('File manager folder set successfully.', '', {
            timeOut: 3000,
          });
        } else {
          this.loaderService.hide();
        }
      } else {
        this.spinner = false;
        this.loaderService.hide();
      }
    });
  }

  SetDefaultAutomationFolderForCore() {
    var reqModel = {
      folderID: this.data.fileManagerItemID,
      aiAutomationTemplateID: this.aiAutomationTemplateID,
      type: 2,//  1 for referral  , 2 for Core
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId)
    }
    this.loaderService.show();
    this.settingsService.setDefaultAutomationFolderForCore(reqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.dialogRef.close("RecordAdded");
          this.toastr.success('Folder set for core automation successfully.', '', {
            timeOut: 3000,
          });
        } else {
          this.loaderService.hide();
        }
      } else {
        this.spinner = false;
        this.loaderService.hide();
      }
    });
  }

}
